import React from 'react';

import { AsmanPDFContainer } from '@bvt-features/sub-module/asman/container/AsmanPDF.container';
export const AsmanPDFLayout = () => {
  return <AsmanPDFContainer />;
};
